export const isFieldVisible = (
  fieldName,
  refundModalType,
  customPaymentType,
) => {
  const fieldConfig = customPaymentType?.createRefundConfig;

  const field = fieldConfig?.find((config) => config.field === fieldName);
  console.log(refundModalType, field?.isVisible?.[refundModalType]);

  return field?.isVisible?.[refundModalType] || false;
};

export const getFieldName = (fieldName, customPaymentType) => {
  const fieldConfig = customPaymentType?.createRefundConfig;
  const field = fieldConfig?.find((config) => config.field === fieldName);
  return field?.name || '';
};

export const getFieldLabel = (baseLabel, fieldName, customPaymentType) => {
  const configName = getFieldName(fieldName, customPaymentType);
  return configName ? `${baseLabel} (${configName})` : baseLabel;
};
